// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
  Taken basically right from the JwmLinkedWorkspace.less
  file. I think this could be a good candidate for
  more refactoring to unify the linked projects
  and invite rows components on the workspace sidebar
  since the styles are very similar and behave
  similarly.
  */
.Z78UW6ykyCJlfi {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-left: 10px;
  border-radius: 0;
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
}
._BWmbdcTVIjRR_ {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-left: 10px;
  border-radius: 0;
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
  background-color: transparent;
}
._BWmbdcTVIjRR_:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 0%, 0.08));
  text-decoration: none;
}
.body-dark-board-background ._BWmbdcTVIjRR_:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
html[data-color-mode='dark'] ._BWmbdcTVIjRR_:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
._BWmbdcTVIjRR_:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 0%, 0.16));
}
.body-dark-board-background ._BWmbdcTVIjRR_:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
html[data-color-mode='dark'] ._BWmbdcTVIjRR_:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
.QMbEHPcxNx13_p {
  flex: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  color: var(--dynamic-text);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mzh8af67AhjnA0 {
  margin: var(--ds-space-0, 0) var(--ds-space-075, 6px);
  padding: var(--ds-space-050, 4px);
}
.JohU65X3YcqsoI {
  padding: var(--ds-space-050, 4px);
}
.wqyX0cAl3GDiHI {
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspaceLinkRow": `Z78UW6ykyCJlfi`,
	"workspaceLink": `_BWmbdcTVIjRR_`,
	"workspaceLinkText": `QMbEHPcxNx13_p`,
	"shortcutIcon": `mzh8af67AhjnA0`,
	"shortcutIconFlagEnabled": `JohU65X3YcqsoI`,
	"newWorkspacePage": `wqyX0cAl3GDiHI`
};
export default ___CSS_LOADER_EXPORT___;
